<template>
  <div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 tabvertical">
        <c-tab
          :dense="true"
          type="pagetop"
          :tabItems.sync="tabItems"
          :inlineLabel="true"
          v-model="tab"
          align="left"
        >
          <template v-slot:default="tab">
            <component
              :is="tab.component"
              :param="popupParam"
            />
          </template>
        </c-tab>
      </div>
    </div>
  </div>
</template>
<script>
// import selectConfig from '@/js/selectConfig';
// import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'air-master-manage',
  props: {
    popupParam: {
      type: Object,
      default(){
        return {
          title: '',
        }
      },
    },
    contentHeight: null,
  },
  data() {
    return {
      splitter: { data: 220 },
      tab: 'tab1',
      tabItems: [
        { name: 'tab1', label: '배출구별 검사항목별 추이분석', component: () => import(`${'./selfAirMeasureGraph1.vue'}`) },
        // { name: 'tab2', label: '측정 회차별 추이분석', component: () => import(`${'./selfAirMeasureGraph2.vue'}`) },
      ],
    };
  },

  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    tabHeight() {
      return String(this.contentHeight - 220);
    },
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.getData();
    },
    getData() {
    },
  }
};
</script>